import { render, staticRenderFns } from "./PCodeEditor.vue?vue&type=template&id=79c51a5a"
import script from "./PCodeEditor.vue?vue&type=script&lang=js"
export * from "./PCodeEditor.vue?vue&type=script&lang=js"
import style0 from "./PCodeEditor.vue?vue&type=style&index=0&id=79c51a5a&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports